import { ReactNode } from 'react'
import { create } from 'zustand'

export enum ActionPopupTypes {
  ALERT = 'ALERT',
  CONFIRM = 'CONFIRM',
}

export interface ActionPopupOptions {
  title?: string
  actionsAdditionalSlot?: ReactNode
  alertCloseText?: string
  confirmDenyText?: string
  confirmAcceptText?: string
  confirmDisabledText?: string
  disableGlobalActionPopup?: boolean
  hideSecondaryButton?: boolean
}

interface ActionPopupState {
  body: string | ReactNode | undefined
  type: ActionPopupTypes | undefined
  isShown: boolean
  options: ActionPopupOptions

  open: (body: string | ReactNode, type: ActionPopupTypes, options?: ActionPopupOptions) => void
  close: () => void
}

const defaultOptions: ActionPopupOptions = {
  title: undefined,
  actionsAdditionalSlot: undefined,
  alertCloseText: undefined,
  confirmDenyText: undefined,
  confirmAcceptText: undefined,
  confirmDisabledText: undefined,
  disableGlobalActionPopup: false,
  hideSecondaryButton: false,
}

export const useActionPopupStore = create<ActionPopupState>((set) => ({
  body: undefined,
  type: undefined,
  isShown: false,
  options: { ...defaultOptions },

  open: (body, type, options) => set({
    body,
    type,
    isShown: true,
    options: { ...defaultOptions, ...options },
  }),

  close: () => set({
    body: undefined,
    type: undefined,
    isShown: false,
    options: { ...defaultOptions },
  }),
}))
